// src\themes\lino\components\ProductView.tsx
import Container from "@/components/shared/Container";
import { ShopTag } from "@/core/models/shop-tag-model";
import Link from "next/link";
import { MainShopProduct, ProductColor } from "@/core/models/shop-product-model";
import RelatedProducts from "../elements/Product/RelatedProducts";
import ProductInformation from "../elements/Product/ProductInformation";
import ProductGallery from "../elements/Product/ProductGallery";
import ProductComments from "../elements/comment/ProductComment";
import WidgetsRender from "@/components/main/widgets/WidgetsRender";

interface GalleryData {
    image_info: Array<{
        url: string;
        alt?: string;
    }>;
}

interface ProductViewProps {
    product: MainShopProduct;
    gallery: GalleryData;
    colors: ProductColor[];
    id: number;
}

export default function ProductView({ product, gallery, colors, id }: ProductViewProps) {
    return (
        <Container className="flex flex-col gap-12 mt-8 px-4">
            <div className="grid grid-cols-1 md:grid-cols-5 gap-8 lg:gap-12">
                <div className="col-span-1 md:col-span-3">
                    <ProductGallery images={gallery.image_info} product={product} />
                </div>
                <aside className="col-span-1 md:col-span-2 md:sticky md:top-28 h-fit">
                    <ProductInformation product={product} colors={colors} />
                </aside>
            </div>
            {product.tags.length > 0 && (
                <div className="flex flex-wrap gap-2.5 -mt-6">
                    {product.tags.map((tag: ShopTag) => (
                        <Link
                            key={tag.id}
                            href={`/shop/category/products/all?tag=${tag.slug}`}
                            className="inline-block rounded-full px-3.5 py-1.5 border border-primary-200 text-primary-700 text-[11px] tracking-wide hover:border-primary-900 hover:text-primary-900 transition-colors no-underline"
                        >
                            #{tag.title}
                        </Link>
                    ))}
                </div>
            )}
            {
                product.blog &&
                <div className="grid grid-cols-12 gap-x-4 gap-y-8 md:gap-x-8 md:gap-y-10 lg:gap-y-12 lg:gap-x-10 mx-auto ">
                    <WidgetsRender widgets={product.blog.content} />
                </div>
            }
            <RelatedProducts productId={id} />
            <ProductComments productId={id} />
        </Container>
    )
}